import { type ReactNode } from 'react'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'

export type EditTab = 'details' | 'appearance' | 'hosts' | 'entertainment' | 'links' | 'selling' | 'sponsors'

export default function CampaignEditorTabs({
  activeTab,
  onTabChange,
  fundraiser,
  children,
}: {
  activeTab: EditTab
  onTabChange: (tab: EditTab) => void
  fundraiser: boolean
  children: ReactNode
}) {
  const tabs: { value: EditTab; label: string }[] = fundraiser
    ? [
        { value: 'details', label: 'Details' },
        { value: 'appearance', label: 'Appearance' },
      ]
    : [
        { value: 'details', label: 'Details' },
        { value: 'appearance', label: 'Appearance' },
        { value: 'hosts', label: 'Hosts & honorees' },
        { value: 'entertainment', label: 'Entertainment' },
        { value: 'links', label: 'Event links' },
      ]

  const hideTabBar = activeTab === 'selling' || activeTab === 'sponsors'

  return (
    <Tabs value={activeTab} onValueChange={(value) => onTabChange(value as EditTab)} className="gap-0">
      {!hideTabBar && (
        <div className="border-b border-black/10">
          <TabsList variant="line" className="h-10 w-full justify-start rounded-none bg-transparent p-0">
            {tabs.map((tab) => (
              <TabsTrigger key={tab.value} value={tab.value} className="h-10 flex-none px-3 text-sm">
                {tab.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </div>
      )}
      {children}
    </Tabs>
  )
}
